import { graphql } from '@/gql'

export const RunBatchActionMutation = graphql(`
  mutation RunBatchAction($input: RunBatchActionInput!) {
    runBatchAction(input: $input) {
      batchId
      action
      batchDeleted
      batch {
        id
        processingItemsCount: itemsCountByStatus(status: [PROCESSING])
        processedItemsCount: itemsCountByStatus(status: [PROCESSED])
      }
      resultUrl
    }
  }
`)
